var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"his_edit_opinion"},[_c('back-step',{attrs:{"goList":[{
      url: '/cases',
      name: _vm.$t('casesDetail.casesChildren.common.bl')
    }, {
      url: '/cases/detail',
      name: _vm.$t('casesDetail.casesChildren.common.blxq')
    }],"currentTxt":_vm.$t('casesDetail.casesChildren.hisTextPlan.wzlsxgyj')}}),_c('h5',{staticClass:"oper_tit"},[_vm._v(_vm._s(_vm.$t('casesDetail.casesChildren.hisTextPlan.fabh'))+"："+_vm._s(_vm.curePlanId))]),_c('his-plan')],1)}
var staticRenderFns = []

export { render, staticRenderFns }